import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import {
  setTabOrPublicationPage,
  setLastPublicationNumber,
} from '../../../../../redux/slices/appSlice';
import { setCurrentPublication } from '../../../../../redux/slices/currentPublicationSlice';

const ItemCard = ({ item, globalIndex }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentTab = useSelector((state) => state.currentTab.currentTab);
  const imgs_for_filters = useSelector((state) => state.others_data.imgs_for_filters);

  const [itemData, setItemData] = React.useState(null);
  const [contentData, setContentData] = React.useState(null);
  const cardRef = React.useRef(null);

  React.useEffect(() => {
    if (item) {
      setItemData(item);
    }
  }, [item]);

  React.useEffect(() => {
    if (cardRef.current && item?.eng_name) {
      const rect = cardRef.current.getBoundingClientRect();
      if (rect) {
        const coordinates = {
          eng_name: item.eng_name,
          template_name: item.template?.template_name,
          parent_tab: item.parent_tab,
          x: rect.left,
          y: rect.top,
          width: rect.width,
          height: rect.height,
          scrollY: window.scrollY,
          absoluteY: rect.top + window.scrollY,
        };
        if (!window.cardCoordinates) {
          window.cardCoordinates = {};
        }
        window.cardCoordinates[item.eng_name] = coordinates;
      }
    }
  }, [contentData, item]);

  React.useEffect(() => {
    if (itemData && itemData.content) {
      try {
        const parsedContent = JSON.parse(itemData.content);
        setContentData(parsedContent);
      } catch (error) {
        setContentData(null);
      }
    }
  }, [itemData]);

  const filterA = React.useMemo(() => {
    if (!item?.item_settings) return null;
    try {
      const settings = JSON.parse(item.item_settings);
      return settings.item_filter_a || null;
    } catch (error) {
      return null;
    }
  }, [item?.item_settings]);

  const filterB = React.useMemo(() => {
    if (!item?.item_settings) return null;
    try {
      const settings = JSON.parse(item.item_settings);
      return settings.item_filter_b || null;
    } catch (error) {
      return null;
    }
  }, [item?.item_settings]);

  const getFilterImage = (filterValue) => {
    if (!imgs_for_filters || imgs_for_filters.length === 0) return null;
    const filterImg = imgs_for_filters.find((imgData) => imgData.word === filterValue);
    return filterImg ? filterImg.img : null;
  };

  const handleCardClick = () => {
    if (itemData && currentTab) {
      const targetPath =
        currentTab.eng_name === 'main_tab'
          ? '/' + itemData.eng_name
          : '/' + currentTab.eng_name + '/' + itemData.eng_name;
      if (globalIndex != null) {
        dispatch(setLastPublicationNumber(globalIndex));
      }
      dispatch(setCurrentPublication(itemData));
      dispatch(setTabOrPublicationPage('publication'));
      navigate(targetPath);
    }
  };

  return (
    <div
      ref={cardRef}
      className={styles.itemCard}
      onClick={handleCardClick}
      style={{ cursor: 'pointer' }}
      data-eng-name={item?.eng_name}
      data-template-name={item?.template?.template_name}
      data-parent-tab={item?.parent_tab}>
      {filterB && filterB !== 'все' && (
        <div className={styles.filterBDisplay}>
          {Array.isArray(filterB) ? filterB.join(', ') : String(filterB)}
        </div>
      )}

      {contentData && Array.isArray(contentData) && contentData[0] && (
        <div className={styles.contentContainer}>
          <div className={styles.blockWrapper}>
            {contentData[0].block_content && (
              <div className={styles.blockContent}>
                {Array.isArray(contentData[0].block_content)
                  ? (() => {
                      const titleItem = contentData[0].block_content.find(
                        (el) => el.cotent_tag === 'item_name' || el.content_tag === 'item_name',
                      );
                      const priceItem = contentData[0].block_content.find(
                        (el) => el.cotent_tag === 'price_info' || el.content_tag === 'price_info',
                      );
                      const descriptionItem = contentData[0].block_content.find(
                        (el) => el.cotent_tag === 'item_img' || el.content_tag === 'item_img',
                      );

                      return (
                        <>
                          {(titleItem || priceItem) && (
                            <div className={styles.titlePriceRow}>
                              {titleItem && (
                                <div className={styles.itemTitleInline}>
                                  <div className={styles.itemTitleContainer}>
                                    <h2 className={styles.itemTitleText}>
                                      {titleItem.content_text}
                                    </h2>
                                  </div>
                                  {filterA && filterA !== 'все' && (
                                    <div className={styles.filterAContainer}>
                                      <div className={styles.filterAWrapper}>
                                        {getFilterImage(filterA) ? (
                                          <img
                                            src={getFilterImage(filterA)}
                                            alt={filterA}
                                            className={styles.filterAImage}
                                          />
                                        ) : (
                                          <span className={styles.filterAText}>
                                            {Array.isArray(filterA)
                                              ? filterA.join(', ')
                                              : String(filterA)}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                              {priceItem && (
                                <div className={styles.contentPrice}>{priceItem.content_text}</div>
                              )}
                            </div>
                          )}

                          {contentData[0].block_content
                            .filter(
                              (contentItem) =>
                                (contentItem.cotent_type === 'img' ||
                                  contentItem.content_type === 'img') &&
                                contentItem.img_name,
                            )
                            .slice(0, 1)
                            .map((contentItem, contentIndex) => {
                              const processedImgName = contentItem.img_name.includes('\\')
                                ? contentItem.img_name.substring(
                                    contentItem.img_name.lastIndexOf('\\') + 1,
                                  )
                                : contentItem.img_name;
                              const imageUrl = `http://${itemData?.path}${itemData?.eng_name}/${processedImgName}`;
                              return (
                                <div key={contentIndex} className={styles.contentImage}>
                                  <img
                                    src={imageUrl}
                                    alt={contentItem.content_text || 'Изображение'}
                                    className={styles.image}
                                  />
                                </div>
                              );
                            })}

                          <div className={styles.descriptionArea}>
                            <div className={styles.descriptionAreaInner}>
                              {descriptionItem?.content_text &&
                                descriptionItem.content_text.trim() !== '' &&
                                descriptionItem.content_text.toLowerCase() !== 'none' && (
                                  <div className={styles.contentText}>
                                    {descriptionItem.content_text}
                                  </div>
                                )}

                              {contentData[0].block_content
                                .filter(
                                  (contentItem) =>
                                    contentItem.content_text &&
                                    contentItem.cotent_tag !== 'item_name' &&
                                    contentItem.content_tag !== 'item_name' &&
                                    contentItem.cotent_tag !== 'price_info' &&
                                    contentItem.content_tag !== 'price_info' &&
                                    contentItem.cotent_tag !== 'item_img' &&
                                    contentItem.content_tag !== 'item_img' &&
                                    contentItem.cotent_type !== 'img' &&
                                    contentItem.content_type !== 'img',
                                )
                                .map((contentItem, contentIndex) => {
                                  if (
                                    !contentItem.content_text ||
                                    contentItem.content_text.trim() === '' ||
                                    contentItem.content_text.toLowerCase() === 'none'
                                  ) {
                                    return null;
                                  }
                                  return (
                                    <div key={contentIndex} className={styles.contentText}>
                                      {contentItem.content_text}
                                    </div>
                                  );
                                })}
                            </div>
                          </div>

                          <button
                            className={styles.detailsButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCardClick();
                            }}>
                            Подробнее
                          </button>
                        </>
                      );
                    })()
                  : null}
              </div>
            )}
          </div>
        </div>
      )}

      {(!contentData || !Array.isArray(contentData) || contentData.length === 0) && (
        <div className={styles.noContentMessage}>Контент не найден</div>
      )}
    </div>
  );
};

export default ItemCard;
